import React, { Component } from 'react'
import * as d3base from 'd3-axis'
import { select as d3Select } from 'd3-selection'
import moment, { MomentInput } from 'moment'
import type { Data, Tick } from './index'

type Props = {
  data?: Data,
  orient: string,
  scale: any, // eslint-disable-line
  tick?: Tick,
  tickSize: number,
  translate: string,
  type: string
}

export default class Axis extends Component<Props> {
  axisElement: Element | string = '';

  componentDidMount(): void {
    this.renderAxis()
  }

  componentDidUpdate(): void {
    this.renderAxis()
  }

  renderAxis(): void {
    const { data, tick, orient, scale, type } = this.props
    const axisType = `axis${orient}` as string;
    const d3 = d3base as ExtendedAxisType;

    // this is to allow us to use strings as index
   type AxisType = typeof d3base;
    type ExtendedAxisType = AxisType & {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any;
    }

    if (data && tick && type === 'production') {
      /* production data x axis */
      const axis = d3[axisType](scale)
      .ticks([4])
      .tickFormat(()=> {return ''})

      d3Select(this.axisElement as Element).call(axis)
    }

    else if (data && tick) {
      /* consumption data x axis */
      const axis = d3[axisType]()
        .scale(scale)
        .tickPadding([12])
        .ticks([4])
        .tickFormat((data:Data) => {
          if (tick.length) {
            return moment(data as MomentInput)
              .format(tick.labelFormat)
              .slice(0, tick.length)
          } else {
            return moment(data as MomentInput).format(tick.labelFormat)
          }
        })

      d3Select(this.axisElement as Element).call(axis)
    }
    else {
      /* y axis */
      const axis = d3[axisType]()
        .scale(scale)
        .tickPadding([12])
        .ticks([4])

      d3Select(this.axisElement as Element).call(axis)
    }
  }

  render(): JSX.Element {
    const { orient, translate } = this.props
    return (
      <g
        className={`axis axis-${orient.toLowerCase()}`}
        ref={el => {
          if (el) this.axisElement = el
        }}
        transform={translate}
      />
    )
  }
}
